import { AppConfigModel } from "../../abstract/app-config.model";

export class BankAccountType extends AppConfigModel {

    static override CLASS_NAME: string = 'BankAccountType';
}
